export var getQuoteSource = function getQuoteSource(quoteSource, quoteDateTime) {
  return "".concat(quoteSource, " (").concat(quoteDateTime, ")");
};